import React, { Component } from 'react';
import { Button, Grid, Dialog, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { AgGridReact } from 'ag-grid-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {concat as _concat, cloneDeep as _cloneDeep} from 'lodash';
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';

import LoadingOverlay from 'components/common/loadingOverlay';
import {TranStyle} from './TranStyle';
import { TranGrid } from './TranGrid';
import { prepareExport } from './prepareExport';
import './Tran.css'

import Constants from 'components/utils/constants'
import NewTran from './NewTran';
import mapDispatchToProps from 'reducers/actions/dispatchProps';
import mapStateToProps from 'reducers/actions/stateToProps';
import LinkTran from './LinkTran';
import CopyTran from './CopyTran';
import WidgetYearlyTrend from 'components/widgets/YearlyTrend';
import WidgetTranTypeSplits from 'components/widgets/TranTypeSplits';
import { withSnackbar } from 'notistack';
import { WebClientStore } from 'web-client-store';
import ReceiptManager from 'components/receipt/ReceiptManager';
import { AccountHandler, ListItemHandler, TransactionHandler } from 'chits-data/dist';
import NewChitTermForm from 'components/account/NewChitTermForm';
import TranBaseActions from './TranBaseActions';
import ChitPayDashboard from 'components/dashboard';
import Messenger from 'components/utils/Messenger';
import Calculator from 'components/widgets/calc/Calculator';
let {Session} = WebClientStore;

let SESSION_KEYS = Constants.SESSION_KEYS;
let defaultFilter = {filterCrDr: -1, filterCrDrText: 'Show Credits Only'};
let _dragStarted = false;
let console = Constants.consoleWrapper(false);
class Tran extends Component {
    constructor(props) {
		super(props);
		this._handler = new TransactionHandler();
		this._accountHandler = new AccountHandler();
		this._itemsHandler = new ListItemHandler();
		// this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	state = {
		gridEditMode: false,
		enabledAdd: false,
		enabledDelete: false,
		enabledUpdate: false,
        enabledBulkUpdate: false,
        enabledAttach: false,
        enabledOpenAttach: false,
		enabledLink: false,
		enabledUnlink: false,
		enabledCopy: false,
		enabledMove: false,
		enabledClone: false,
		enableSubmitOrder: false,
		enableSwapTypes: false,
		enableAddChitTerm: false,
		enableChitPaymentDashboard: false,
		enableDeleteLastChitTerm: true,
		tranTypes: [],
		tranTypesCrDr: [],
		tranTypeObj: {},
		rowsSelected: [],
		rowsToUnlink: [],
		open: {
			createModal   : false,
			updateModal : false,
			bulkUpdateModal: false,
			debitModal: false,
            creditModal: false,
            attachModal: false,
			linkModal: false,
			copyModal: false,
			moveModal: false,
			widgetYearlyTrends: false,
            widgetTranTypeSplits: false,
            confirmation: false,
			chitPaymentDashboard: false,
		},
        roles: {
            owner: false,
            admin: false,
            editor: false,
            viewer: false,
			any: false,
        },
		openOverlay              : false,
		accountLineUp : [Constants.DEFAULT_ACCOUNT],
		selectedAccount: Constants.DEFAULT_ACCOUNT,
		calcVal: '1',
		showCalc: false,
		trans : [],
		transOriginal: [],
		tranOrder: [],
		filters: _cloneDeep(defaultFilter),
		searchTerm: '',
        tranColDef: TranGrid().columnsCompact, //default
        linkReference: '',
		currentChitTerm: 1,
		maxTerms: 1,
		termTrans: [],
		termDateMap: {},
		termCountMap: {},
		dashboardShowDueColumn: true,
		clearCache: this.props.appState.clearCache
	};

	/**
	 * Will be executed once on mount
	 * and every time window resized
   * TODO: Move it to app.js
	 */
	// updateWindowDimensions() {
	// 	if (this.setState) {
	// 		console.debug('capturing new window dimentions [' + window.innerWidth + 'x' + window.innerHeight + ']')
	// 		this.setState({
	// 			width: window.innerWidth,
	// 			height: window.innerHeight
	// 		})
	// 	}
	// }

	extractURLParameters() {
		let _state = this.state;
		try {
			const {match: {params}} = this.props;
			if (params.accountId) {
				Session.set(SESSION_KEYS.ACTIVE_ACCOUNT, params.accountId);
            }
            if (params.linkId) {
				_state.linkReference = params.linkId;
			}	
		} catch (error) {
			console.error(error)
		}
		this.setState(_state);
	}

	componentWillUnmount() {
		// window.removeEventListener('resize', this.updateWindowDimensions);
	}

	componentDidMount = () => {
		// register a 'resize' event to capture the window dimentions
		// window.addEventListener('resize', this.updateWindowDimensions);
		// extract parameters from URL including query params
		this.extractURLParameters();

		// Check if the chit is started; if not redirect to account info page
    	let ac = this._handler.getActiveAccount();
    	// asynchronously load account information to props
		this._accountHandler.getAccountCached(ac).then((account)=>{
			if (account) {
				if (!account.chit_info.nextTerm) {
					window.location.href = '/info?refresh=tran_init';
				} else {
					// update state
					this.props.setCurrentAccount(account);
				}
			} else {
				window.location.href = '/info?refresh=tran_init';
			}
		})
		.finally(()=>{
			// Proceed with fetching accounts
			this.handleGetAccounts()
		})

	};

    handleGetAccounts = async (unset=false) => {
        let _accountLineup = [];
        let _roles = this.state.roles;
        let defaultAccount = Constants.DEFAULT_ACCOUNT;
        let requested = defaultAccount;
        // let retrieveFrom = Constants.URLs.ACCOUNTS;
        this.setState({ openOverlay: true });
        this._accountHandler.getAccountsCached(unset).then((accounts) => {
            // Display only ACTIVE accounts; sorted by type
            let _accounts = Constants.sortAccountsByType(accounts.filter(ac=>{
                let isValid = ac.type === "CHIT";
                // if (ac.type === "CHIT") {
                //     isValid = ac.chit_info && ac.chit_info.nextTerm && ac.chit_info.nextTerm > 0;
                // }
                return ac.status==="ac" && isValid
            }));
            _accountLineup = _concat(defaultAccount, _accounts);
            let activeAccountId = Session.get(SESSION_KEYS.ACTIVE_ACCOUNT);
            if (activeAccountId !== undefined && activeAccountId !== '') {
                requested = accounts.filter((item) => {
                    if(this.props.caller && this.props.caller === "AccountInfo") {
                        return item._id === activeAccountId;
                    } else {
                        //Any page other than account info must be restricted to non-active accounts
                        return item._id === activeAccountId && item.status === 'ac';
                    }
                })[0];
            }
            // console.log('identified object by the supplied param is:' + JSON.stringify(requested));
            if (!requested) {
                requested = defaultAccount;
                this.props.enqueueSnackbar('Requested account is not accessible. Please chose a valid account.', {
                    variant: 'warning'
                });
            } else {
                if (requested && requested.hasOwnProperty('curr') && requested.curr !== '') {
                    Session.set(SESSION_KEYS.ACTIVE_ACCOUNT_CURR, requested.curr);
                }
                if (requested && requested.hasOwnProperty('type') && requested.type !== '') {
                    Session.set(SESSION_KEYS.ACTIVE_ACCOUNT_TYPE, requested.type);
                }
                _roles.owner = requested.isOwner || false;
                _roles.admin = requested.isAdmin || false;
                _roles.editor = requested.isEditor || false;
                _roles.viewer = requested.isViewer || false;
                _roles.any = requested.isOwner || requested.isAdmin || requested.isEditor || requested.isViewer;
            }
            
            this.setState({
                openOverlay: false,
                roles: _roles,
                selectedAccount: requested,
                accounts: _accountLineup
            })
            this.props.setCurrentAccount(requested);
            this.handlePreProcessor(_accountLineup, requested, _roles);
        })
    }

	handlePreProcessor = (accounts, ac, roles, trans) => {
		// console.log('AccountInfo->renderActionInfoForm->AFTER ac', ac);
		let {type, chit_info} = ac;
		if (type !== "CHIT") return;
		let {nextTerm, chit_tenure} = chit_info;
		let _currentChitTerm = 1;
		let _maxTerms = 1;
		if (nextTerm && nextTerm > 0) {
			_currentChitTerm = nextTerm - 1;
			_maxTerms = nextTerm - 1;
		} else {
			_currentChitTerm = chit_tenure;
			_maxTerms = chit_tenure;
		}
		this.setState({
			enabledAdd: ((roles.owner || roles.admin || roles.editor) && ac.code !== 'unknown' && ac.type !== 'CHIT'),
			filters: _cloneDeep(defaultFilter),
			accountLineUp: accounts,
			selectedAccount: ac,
			roles,
			currentChitTerm: _currentChitTerm,
			maxTerms: _maxTerms
		})
		if (ac._id !== 'unknown') {
			this.handleGetListItems(true);
		}
	}

	handleGetListItems = async (quite=false) => {
		// Session.set(SESSION_KEYS.ACTIVE_TRAN_TYPE, 'Unknown');
		// let retrieveFrom = Constants.URLs.TRAN_TYPES + '/ac';
		let type = 'CHIT'; //default value
		if (Session.get(SESSION_KEYS.ACTIVE_ACCOUNT_TYPE)) {
			type = Session.get(SESSION_KEYS.ACTIVE_ACCOUNT_TYPE);
		}
		// this.setState({ openOverlay: true });
		// this._accountHandler.getInstance()
		// 	.post(retrieveFrom, {acType: type})
		this._itemsHandler.getTranTypesByAcCached(type)
			.then((response) => {
				let trans = response.data;
				let typeObj = trans.reduce((obj, type)=>{
					obj[type.code] = type.name;
					return obj;
				},{});
				// console.log('typeObj', typeObj);
				let sorted = trans.sort((a, b)=> {
					if (a.code < b.code) return -1;
					return 0;
				});
				this.setState({ 
					openOverlay: false, 
					enabledDelete: false,
					enabledUpdate: false, 
					enabledBulkUpdate: false, 
					enabledLink: false, 
					enabledUnlink: false, 
					enabledCopy: false,
					enabledMove: false,
					enabledClone: false,
					enabledAttach: false,
					enabledOpenAttach: false,
					tranTypes: sorted, 
					tranTypesCrDr: sorted,
					tranTypeObj: typeObj
				});
			})
			.catch((error) => {
				// if (error.response)
				// console.log(error);
				// this.props.enqueueSnackbar('Error: Could not be able to retrieve accounts', {
				// 	variant : 'error'
				// });
			}).finally(()=>{
				this.handleRefreshRequest(quite);
			})
	}

	handleRefreshRequest = (quite = false) => {
		if (Session.get('force_refresh')) {
			Session.unset('force_refresh');
			this.handleRefreshTranGrid(quite, true);
		} else {
			this.handleRefreshTranGrid(quite, false);
		}
	}

	handleRefreshTranGrid = (quite = false, clearCache=false) => {
		let _termDateMap = this.state.termDateMap;
		if (Session.get(SESSION_KEYS.ACTIVE_ACCOUNT)) {
            let ac = Session.get(SESSION_KEYS.ACTIVE_ACCOUNT);
            if (ac === 'unknown') {
                return;
            }
		 	// let retrieveFrom = `${Constants.URLs.TRANS_OF_ACCOUNT}/${ac}`;
			this.setState({ filters: _cloneDeep(defaultFilter) });
			let _trans = this.state.trans;
				// .get(retrieveFrom)
			let _clearCache = clearCache || this.state.clearCache;
			this._accountHandler.getAccountTransCached(ac, _clearCache)
				.then((transactions) => {
					let typeObj = this.state.tranTypeObj;/* .reduce((obj, type)=>{
						obj[type.code] = type.name;
						return obj;
					},{}); */
					let data = transactions; //.docs;
					//inject transaction type name from code
					let _termCountMap = this.state.termCountMap;
					data.forEach((t)=>{
						if (typeObj.hasOwnProperty(t.type)) {
							t.typeName = typeObj[t.type]
						}

						// Also prepare term vs date map
						if (t.chit_info) {
							let { term, date } = t.chit_info;
							if (term && date) {
								_termDateMap[term] = date;
								//Count for each term
								if (!_termCountMap[term]) _termCountMap[term] = 0;
								_termCountMap[term]++;
							}
						}
					});
					console.debug('_termDateMap', _termDateMap);
					let orders = data.reduce((arr, item) => {
						arr.push({ _id: item._id, sno: item.sno });
						return arr;
					}, []);
					if (!quite) {
						this.props.enqueueSnackbar('Transactions refreshed successfully.', {
							variant : 'success',
							autoHideDuration: 1000
						});
					}
					_trans = data;
					this.setState({ trans: data, transOriginal: _cloneDeep(data), tranOrder: orders });
				})
				.catch((error) => {
					console.log(error);
					if (!quite) {
						this.props.enqueueSnackbar('Error: Could not be able to retrieve funds', {
							variant : 'error'
						});
					}
				})
				.finally(()=>{
					if (Session.get(ac + '_req_ts')) {
						Session.unset(ac + '_req_ts');
					}
					this.setState({ 
						enabledDelete: false,
						enabledUpdate: false, 
						enabledBulkUpdate: false, 
						enabledLink: false, 
						enabledUnlink: false, 
						enabledCopy: false,
						enabledMove: false,
						enabledClone: false,
						rowsSelected: [],
						gridEditMode: false,
						enabledAttach: false,
						enabledOpenAttach: false,
						enableChitPaymentDashboard: _trans.length > 0,
						clearCache: false,
						termDateMap: _termDateMap
					});

					// this.handleEditMode();

					//scroll to referenced link row
					// let {trans, linkReference} = this.state;
					// if (linkReference) {
					// 	// console.log('link reference received:' + linkReference);
					// 	let index = -1;
					// 	trans.some(function (tran) {
					// 			// console.log('searching at index:'+ index + " value: " + tran._id)
					// 			index++;
					// 			return (tran._id === linkReference);
					// 	});
					// 	// console.log("scrolling to position:" + index);
					// 	if (this.gridApi) {
					// 			this.gridApi.ensureIndexVisible(index);
					// 	}
					// }
					if (this.gridApi) {
							this.handleUpdateGridTransactionData(_trans);
					}

					// //hide link/beneficiary columsn in trans page
					// if (this.gridColumnApi) {
					//     this.gridColumnApi.setColumnVisible('link_io', this.state.roles.owner);
					//     this.gridColumnApi.setColumnVisible('link_ac.code', this.state.roles.owner);
					// }
				})
		}
	};

	handleUpdateGridTransactionData = (trans=[], term) => {
		// console.log('updateGridTransactionData()')
		let _term = term ? term : this.state.currentChitTerm;
		let _trans = trans && trans.length > 0 ? trans : this.state.trans;
		// console.log("filtering transactions for term: ", _term);
		let _termTrans = _term === -1 ? _trans : _trans.filter((tran)=>{
			// Special case; if a member won the bid in this term -
			// There should be only one row indicating both winning bid -
			// and 
			return tran.chit_info.term === _term
		});
		// console.log('filtered trans', _termTrans)
		this.gridApi.setRowData(_termTrans);
		this.setState({
			currentChitTerm: _term,
			// termTrans: _termTrans
		})
	}

    handleForceReloadAccount = () => {
        return (
            this._accountHandler.getAccountCached(this.state.selectedAccount._id, true).then((ac)=>{
                // console.log('AccountInfo->renderActionInfoForm->AFTER ac', ac);
				// console.log('setting _currentChitTerm', _currentChitTerm);
                this.setState({ 
					selectedAccount: ac,
				});
                // force-refresh dashboard/transactions on next visit to transactions page
                Constants.requestPaymentDashboardRefresh(this.state.selectedAccount._id)
                // window.location.reload();
				window.location.href = "/transactions/ac/" + this.state.selectedAccount._id + "?refresh=1"
            })
        )
    }

	handleRowHighlights = params => {
		// let isCC = (Session.get(SESSION_KEYS.ACTIVE_ACCOUNT_TYPE) && 
		// 		(Session.get(SESSION_KEYS.ACTIVE_ACCOUNT_TYPE) === 'CC'));
		let isCC = false;
		let isBid = false;
		try {
			isBid = params.data.chit_info.sub.isBid;
		} catch (error) {
			//
		}
		if (params.data.cr > 0) return isCC ? 'tran-debit-row' : 'tran-credit-row';
		if (params.data.dr > 0 && isBid) return isCC ? 'tran-credit-row': 'tran-debit-row';
	}
	
	handleOpenModal = async (modal) => {
		let tran = this.state.rowsSelected[0];
		let showModal = this.state.open;
		showModal.createModal = false;
		showModal.updateModal = false;
		showModal.bulkUpdateModal = false;
		showModal.linkModal = false;
		showModal.copyModal = false;
		showModal.moveModal = false;
		showModal.debitModal = false;
        showModal.creditModal = false;
        showModal.confirmation = false;
		let filterCrDr = "B";
		switch (modal) {
			case 'credit':
                filterCrDr = "C"
				showModal.createModal = true;
				showModal.creditModal = true;
				break;
			case 'debit':
				filterCrDr = "D";
				showModal.createModal = true;
				showModal.debitModal = true;
				break;
			case 'update':
				if (tran && tran._id !== null && tran._id !== '') {
					if (tran.cr > 0) {
                        showModal.creditModal = true;
                        filterCrDr = "C"
					} else {
						filterCrDr = "D"
						showModal.debitModal = true;
					}
					showModal.updateModal = true;
				} else {
					this.props.enqueueSnackbar('Please chose a valid transaction to update.', {
						variant : 'warning'
					});
				}
				break;
			case 'bulkupdate':
				showModal.bulkUpdateModal = true;
                break;
            case 'attach':
                showModal.attachModal = true;
                break;
			case 'link':
				if (tran && tran._id !== null && tran._id !== '') {
					if (tran.dr > 0) {
                        showModal.creditModal = true;
                        filterCrDr = "C"
					} else {
						filterCrDr = "D"
						showModal.debitModal = true;
					}
					showModal.linkModal = true;
				} else {
					this.props.enqueueSnackbar('Please chose a valid transaction to link.', {
						variant : 'warning'
					});
				}
				break;
			case 'bulk':
					showModal.linkModal = true;
				break;
			case 'copy':
					showModal.copyModal = true;
				break;
			case 'move':
					showModal.moveModal = true;
				break;
			case 'graph1':
				showModal.widgetYearlyTrends = true;
				break;
			case 'graph2':
				showModal.widgetTranTypeSplits = true;
                break;
            case 'confirmation':
                showModal.confirmation = true;
                break;
			case 'chit-pay-dashboard':
				showModal.chitPaymentDashboard = !showModal.chitPaymentDashboard;
				break;
			default:
				break;
		}

		let _tranTypesCrDr = this.state.tranTypes.filter((type)=>{
			if (type.tag === 'B') {
                return true;
            } else if ((type.tag === 'C' || type.tag === 'D') && filterCrDr === 'B') {
                return true;
            } 
            return type.tag === filterCrDr;
		});


		this.setState({
			open                  : showModal,
			tranTypesCrDr         : _tranTypesCrDr
		});
	};

	handleCloseModal = () => {
		let showModal = this.state.open;
		showModal.createModal = false;
		showModal.updateModal = false;
		showModal.bulkUpdateModal = false;
		showModal.attachModal = false;
		showModal.linkModal = false;
		showModal.copyModal = false;
		showModal.moveModal = false;
		showModal.creditModal = false;
		showModal.debitModal = false;
		showModal.widgetYearlyTrends = false;
        showModal.widgetTranTypeSplits = false;
        showModal.confirmation = false;
		showModal.chitPaymentDashboard = false;
		this.setState({
			open             : showModal
		});
	};

	handleDownloadTrans = async () => {
		this.gridApi.exportDataAsCsv(
			this.state.selectedAccount.type === 'CHIT' ?
			prepareExport.exportChitTrans(this.state.selectedAccount.name) :
			prepareExport.exportAccountTrans(this.state.selectedAccount.name)
		);
	}

	handleDeleteTrans = async () => {
		let rowsToDelete = this.state.rowsSelected;
		let selected = rowsToDelete.reduce((arr, item) => {
			arr.push({_id: item._id});
			return arr;
		}, []);
		let payload = {
			account: Session.get(SESSION_KEYS.ACTIVE_ACCOUNT),
			trans: selected
		}
		let deleteTranURL = Constants.URLs.TRANS + '/delete';
		let _trans = this.state.trans;
		this.setState({ openOverlay: true });
		this._handler.getInstance()
			.post(deleteTranURL, payload)
			.then((response) => {
				// let cnt = response.data.status.reduce((m, item) => {
				// 	m += item.deleted;
				// 	return m;
				// }, 0);
				this.props.enqueueSnackbar('Transaction(s) deleted successfully', {
					variant : 'success'
				});
				_trans = response.data.data;
			})
			.catch((error) => {
				console.log(error);
				let msg = 'Error while deleting the transaction(s). Please check console.';
				try {
						if (error.response.data.message) msg = error.response.data.message;
				} catch (error) {}
				this.props.enqueueSnackbar(msg, {
					variant : 'error'
				});
			})
			.finally(()=>{
				this.setState({ 
					openOverlay: false, 
					enabledDelete: false, 
					enabledUpdate: false, 
					enabledBulkUpdate: false, 
					enabledLink: false, 
					enabledUnlink: false, 
					enabledCopy: false,
					enabledMove: false,
					enabledClone: false,
					rowsSelected: [], 
					trans: _trans 
				});
				this.handleUpdateGridTransactionData(_trans);
				Session.set('force_refresh', 'delete_trans');
				this.handleRefreshRequest();
			})
	}

	onGridReady = params => {
		this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
		//refresh data
		this.handleUpdateGridTransactionData();
	};

	onSelectionChanged() {
		if (_dragStarted) return;
		let {owner, admin, editor, viewer}  = this.state.roles
		let isAuthorized = owner || admin || editor;
		let flagDelete = false;
		let flagUpdate = false;
		let flagBulkUpdate = false;
		let flagLink = false;
		let flagUnlink = false;
		let flagCopy = false;
		let flagMove = false;
        let flagClone = false;
        let flagAttach = false;
        let flagOpenAttach = false;
		let flagSwapTypes = true;
		let _calcVal = this.state.calcVal;

		let selectedRows = this.gridApi.getSelectedRows();
		let oneRow = selectedRows[0];
		if (oneRow && oneRow._id && oneRow._id !== '') {
			//proceed
			let attachExists = oneRow.hasOwnProperty('receipts') && oneRow.receipts[0];
			if (attachExists) {
				flagOpenAttach = isAuthorized || viewer;
			} else {
				flagAttach = isAuthorized && selectedRows.length === 1;
			}
			//Read the amount value for calculator
			_calcVal = oneRow.bal;
		} else {
			//return;
		}
		let isNotChitFund = this.state.selectedAccount.type !== 'CHIT';
		flagDelete = isNotChitFund && isAuthorized && selectedRows.length > 0;
		flagUpdate = isAuthorized && selectedRows.length === 1;
		flagBulkUpdate = isNotChitFund && isAuthorized && selectedRows.length > 0;
		flagClone = isNotChitFund && isAuthorized && selectedRows.length === 1;
		flagCopy = isNotChitFund && isAuthorized && selectedRows.length > 0;
		flagMove = isNotChitFund && isAuthorized && selectedRows.length > 0;
		flagLink = isNotChitFund && isAuthorized && selectedRows.length > 0;
		if (selectedRows.length === 1 && oneRow.link && oneRow.link !== '') {
			flagLink = false;
		}
		let unlinkFilter = selectedRows.filter((row)=>{
			return row.link !== '';
		});
        flagUnlink = unlinkFilter && unlinkFilter[0] && unlinkFilter[0].link && isAuthorized;
        flagSwapTypes = isNotChitFund && isAuthorized && selectedRows.length > 0;

		this.setState({ 
			rowsSelected: selectedRows, 
			enabledDelete: flagDelete, 
			enabledUpdate: flagUpdate,
			enabledBulkUpdate: flagBulkUpdate,
			enabledLink: flagLink,
			enabledUnlink: flagUnlink,
			enabledCopy: flagCopy,
			enabledMove: flagMove,
            enabledClone: flagClone,
            enabledAttach: flagAttach,
            enabledOpenAttach: flagOpenAttach,
			rowsToUnlink: unlinkFilter,
			enableSwapTypes: flagSwapTypes,
			calcVal: _calcVal
		})
	}

	onCreateColumnFilter = (instance, type, filter) => {
		var creditFilterComponent = this.gridApi.getFilterInstance(instance);
		var model = {
		  type: type,
		  filter: filter,
		  filterTo: null,
		};
		creditFilterComponent.setModel(model);
		this.gridApi.onFilterChanged();
	}

	onDestroyColumnFilter = (instance) => {
		this.gridApi.destroyFilter(instance);
	};

	onRowDragEnter = () => {
		_dragStarted = true;
	}

	onRowDragEnd = async (params) => {
		_dragStarted = false;
		try {
			let original = _cloneDeep(this.state.tranOrder);
			let data = this.state.tranOrder;
			let i = 0;
			params.api.forEachNode((node) => {
				data[i++]._id = node.data._id;
			});
			this.setState({ tranOrder: data, enableSubmitOrder: JSON.stringify(data)!==JSON.stringify(original) })
		} catch (error) {console.log(error)}
	};

	onRowDragLeave = async (params) => {
		_dragStarted = false;
		this.handleUpdateGridTransactionData(this.state.trans);
		this.setState({ enableSubmitOrder: false })
	};

	onSubmitNewTransactionOrder = async ()  => {
		this.setState({ enableSubmitOrder: false, openOverlay: true });
		let payload = {
			account: { _id: Session.get(SESSION_KEYS.ACTIVE_ACCOUNT) },
			trans: this.state.tranOrder
		};
		this._handler.getInstance()
			.patch(Constants.URLs.TRANS + '/reorder', payload)
			.then((response) => {
				this.props.enqueueSnackbar(response.data.message, {
					variant : 'success'
                });
			})
			.catch((error) => {
				console.log(error);
				this.props.enqueueSnackbar('Error: Could not update the transactions', {
					variant : 'error'
                });
            })
            .finally(()=>{
                this.setState({ openOverlay: false, gridEditMode: false });
                this.handleRefreshRequest();
                this.handleEditMode();
            })
	}

	onSubmitSwapTransactions = async ()  => {
		this.setState({ enableSwapTypes: false, openOverlay: true });
		let selected = this.state.rowsSelected.reduce((arr, item) => {
			arr.push({
				_id: item._id,
				cr: item.dr,
				dr: item.cr
				//TODO: Also identify the swapped transaction type (code)
			});
			return arr;
		}, []);
		console.log('to be swapped:\n', selected);

		let payload = {
			account: { _id: Session.get(SESSION_KEYS.ACTIVE_ACCOUNT) },
			trans: selected
		};

		let _selectedAccount = this.state.selectedAccount;
		this._handler.getInstance()
			.patch(Constants.URLs.TRANS + '/many', payload)
			.then((response) => {
				if (response.data.accountNewBal) {
					_selectedAccount.bal = response.data.accountNewBal;
					this.setState({
						selectedAccount: _selectedAccount
					})
				}
				if (response.data.message) {
					this.props.enqueueSnackbar(response.data.message, {
						variant : 'success'
					});
				}
			})
			.catch((error) => {
				console.log(error);
				this.props.enqueueSnackbar('Error: Could not update the transactions', {
					variant : 'error'
                });
            })
            .finally(()=>{
                this.setState({ openOverlay: false, gridEditMode: false });
                this.handleRefreshRequest();
                this.handleEditMode();
            })
	}

	handleEditMode() {
        //console.log('handle Edit mode:' + this.state.gridEditMode)
        let mode = this.state.gridEditMode;
        let _grid = TranGrid(this.state.roles);
		let colDef = _grid.columnsCompact;
		// let colDef = mode ? _grid.columns : 
		// 	(this.state.selectedAccount.type === 'CHIT' ? _grid.columnsLockedChit :
		// 	_grid.columnsLocked);
		// if (this.props.appState.width <= 799) {
		// 	colDef = _grid.columnsCompact;
		// 	if (mode) {
		// 		colDef = _concat({
		// 			width: 40,
		// 			rowDrag: true
		// 		  }, colDef);
		// 	}
        // } 
		let updates = {
			enabledDelete: false,
			enabledUpdate: false,
			enabledBulkUpdate: false,
			enabledLink: false,
			enabledUnlink: false,
			enabledCopy: false,
			enabledMove: false,
			enabledClone: false,
			enableSubmitOrder: false,
			gridEditMode: !mode,
			tranColDef: colDef
		}
		if (mode) {
			let original = _cloneDeep(this.state.transOriginal);
			updates.trans = original;
			this.handleUpdateGridTransactionData(original);
		}
        this.setState(updates);
        
        //hide link/beneficiary columsn in trans page
        // if (this.gridColumnApi) {
        //     this.gridColumnApi.setColumnVisible('link_io', this.state.roles.owner);
        //     this.gridColumnApi.setColumnVisible('link_ac.code', this.state.roles.owner);
        // }
	}

	handleShowCalc(hide=false) {
		let _newVal = !this.state.showCalc;
		if (hide) {
			_newVal = false;
		}
		this.setState({showCalc: _newVal})
	}

	isValidAccountSelected = () => this.state.selectedAccount._id !== Constants.DEFAULT_ACCOUNT._id;


	/**
	 * Render UI components
	 */

	render() {
		return (
			<div className="content-fluid">
				<div className="row">
					<div className="col-lg-9 mx-auto">
						<div className="card"
						>
							<div className="card-header"
                        	style={{ paddingLeft: '1em', paddingRight: '1em', paddingTop: '1em', textAlign: 'center'}}>
								<h4 className="card-title">Account Transactions</h4>
								<p className="card-category"
                                    style={{ color: '#9C27B0', fontWeight: '500' }}
                                >{this.props.wallet.current.name}</p>
							</div>
							{this.state.showCalc && 
								<Calculator 
									question={this.state.calcVal} 
									onClose={()=>this.handleShowCalc(true)}
									/>}
							<div className="card-body"
							style={{ padding: '4px 1px 2px 2px'}}
							>
								<Grid className="row main-actions">
									{/* <span>Chit draw date: xyz</span> */}
									{this.renderActions()}
								</Grid>
								{!this.state.open.chitPaymentDashboard && this.renderGridTitle()}
								{!this.state.open.chitPaymentDashboard && this.renderTranGrid()}
								{this.state.open.chitPaymentDashboard && 
									this.isValidAccountSelected() &&
									this.renderChitPaymentDashboard()}
								{this.state.open.createModal && this.renderModalNewTran()}
								{this.state.enableAddChitTerm && this.renderModalNewChitTermTran()}
								{this.state.open.updateModal && this.renderModalUpdateTran()}
                                {this.state.open.bulkUpdateModal && this.renderModalBulkUpdateTran()}
                                {this.state.open.attachModal && this.renderModalTranAttach()}
								{this.state.open.linkModal && this.renderModalLinkTranMulti()}
								{(this.state.open.copyModal || this.state.open.moveModal) && this.renderModalCopyTranMulti()}
								{this.state.open.widgetYearlyTrends && this.renderWidgetYearlyTrend()}
                                {this.state.open.widgetTranTypeSplits && this.renderWidgetTranTypeSplits()}
                                {this.state.open.confirmation && 
									<Dialog
                                		open={this.state.open.confirmation}>
										<Typography>
                                    		{Messenger.getAccountArchiveConfirmation()}
                                		</Typography>
										<Button onClick={()=>this._accountHandler.deleteAccount()}>Yes</Button>
										<Button onClick={()=>this.handleCloseModal("")}>No</Button>
									</Dialog>}
								{this.state.openOverlay && <LoadingOverlay />}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	renderSelectedAccountBalance() {
		let bal = "unknown";
		let account = this.state.selectedAccount;
		if (account.curr) {
			// console.log('account selected', account);
			let locale = account.curr === 'INR' ? 'en-IN' : 'en-US';
			bal = Number(account.bal);
			let creditBal = '';
			if (account.type === 'CC') {
				if (account.bal <= 0) {
					creditBal = 'credit-bal';
					if (account.bal < 0) bal *= -1;
				}
			}
			bal = bal.toLocaleString(locale, { style: 'currency', currency: account.curr });
			if (creditBal === 'credit-bal' && account.bal < 0) {
				bal += ' CR'
			}
		}
		return (
			<Grid item lg={2} md={2} sm={12} xs={12}>
				<span>{bal}</span>
			</Grid>
		)
	}

	renderActions() {
		return(
			<TranBaseActions 
				history={this.props.history}
				selectedAccount={this.state.selectedAccount}
				trans={this.state.trans}
				accountRoles={this.state.roles}
				isCompact={this.props.appState.width <= 612}
				gridEditMode={this.state.gridEditMode}
				rowsToUnlink={this.state.rowsToUnlink}
				rowsSelected={this.state.rowsSelected}
				// `Core` drop down buttons and callbacks
				enabledAdd={this.state.enabledAdd}
				enableSwapTypes={this.state.enableSwapTypes}
				onSubmitSwapTransactions={()=>this.onSubmitSwapTransactions()}
				enabledUpdate={this.state.enabledUpdate && false} // disabled updating a transaction
				enabledBulkUpdate={this.state.enabledBulkUpdate}
				enabledDelete={this.state.enabledDelete}
				onDeleteTrans={()=>this.handleDeleteTrans()}
				enabledLink={this.state.enabledLink}
				enabledUnlink={this.state.enabledUnlink}
				enabledCopy={this.state.enabledCopy}
				enabledMove={this.state.enabledMove}
				enabledClone={this.state.enabledClone}
				// `More` drop down buttons and callbacks
				onDownloadTrans={()=>this.handleDownloadTrans()}
				// Top bar buttons and callbacks
				enabledAttach={this.state.enabledAttach}
				enabledOpenAttach={this.state.enabledOpenAttach}
				enableSubmitOrder={this.state.enableSubmitOrder}
				onSubmitNewTransactionOrder={()=>this.onSubmitNewTransactionOrder()}
				//Standard callbacks
				onOpenModal={(modal) => this.handleOpenModal(modal)}
				onRefreshTranGrid={(quite)=>this.handleRefreshRequest(quite)}
				onRefreshRequest={()=>{
					Constants.requestTranRefresh()
					this.handleRefreshRequest()
				}}
				onEditMode={()=>this.handleEditMode()}
				onDeleteAccount={()=>this._accountHandler.deleteAccount()}
				onCreateColumnFilter={(i,t,f)=>this.onCreateColumnFilter(i,t,f)}
				onDestroyColumnFilter={(i)=>this.onDestroyColumnFilter(i)}
				onUpdateEnableProperty={(props)=>{
					this.setState(props)
				}}
				onShowCalc={()=>this.handleShowCalc()}
				showOrHideCalc={!this.state.showCalc}
				showChitTerms={!this.state.open.chitPaymentDashboard}
				maxTerms={this.state.maxTerms}
				currentChitTerm={this.state.currentChitTerm}
				onChitTermChange={(term)=>{
					// console.log('onChitTermChange->term', term)
					this.handleUpdateGridTransactionData([], term);
					this.setState({ currentChitTerm: term })
				}}

				onDashboard={()=>{
					// If user clicked Show tran grid; reload page instead of switching over
					// Aggrid is not ready during switchover
					if (this.state.open.chitPaymentDashboard) {
						this.props.changePageTitle('Transactions')
						let _modal = this.state.open;
						_modal.chitPaymentDashboard = !_modal.chitPaymentDashboard
						this.setState({ open: _modal })
					} else {
						this.props.changePageTitle('Dashboard')
						this.handleOpenModal('chit-pay-dashboard')	
					}
				}}
				enableChitPaymentDashboard={false}
				isChitPaymentDashboardShown={false}

				enableDeleteLastChitTerm={this.state.enableDeleteLastChitTerm}
				onDeleteChitTerm={()=>{
					this.handleForceReloadAccount();
				}}
				onReloadRequest={()=>window.location.reload()}

				enableAddChitTerm={this.state.enableAddChitTerm}
				onAddChitTerm={()=> {
					this.setState({
						enableAddChitTerm: true
					})
				}}
			/>
		)
	}

	renderGridTitle() {
		let cnt = this.state.rowsSelected.length;
		let crSum = this.state.rowsSelected.reduce((sum, row)=>{
			sum += row.cr
			return sum;
		}, 0);
		let cr = (Math.round(crSum * 100) / 100).toFixed(2);
		let drSum = this.state.rowsSelected.reduce((sum, row)=>{
			sum += row.dr
			return sum;
		}, 0);
		let dr = (Math.round(drSum * 100) / 100).toFixed(2);
		let diff = (Math.round((cr - dr) * 100) / 100).toFixed(2);
		let { currentChitTerm, termDateMap, termCountMap } = this.state;
		let termDesc = ' for all the terms';
		let termCount = this.state.trans.length;
		if (currentChitTerm > -1) {
			termCount = termCountMap[currentChitTerm];
			termDesc = <><span><strong>Draw: </strong>{termDateMap[currentChitTerm]}</span></>
		}
		return (
			<Grid container id="trans-grid-notification">
				{termCount && <Grid item xs={12}
					style={{
						marginLeft: '-6px',
						marginBottom: '-10px'
					}}
				>
					<span>Viewing <strong>{termCount}</strong> transactions </span>
					{termDesc}
				</Grid>}
			</Grid>
		)
	}

	renderTranGrid() {
		let width = window.innerWidth;
		console.debug('this.state.termTrans', this.state.termTrans)
		const { classes } = this.props;
        const agStyles = `ag-theme-balham ${classes.agThemeModified}`;
		const autoSizeStrategy = {
			type: 'fitGridWidth',
			// defaultMinWidth: 80,
			// columnLimits: [
			// 	{
			// 		colId: 'date',
			// 		minWidth: 600
			// 	}
			// ]
		};
		let fontSizeRatio = '0.8rem';
		let rowHeight = 30;
		if (width <= 992 && width > 419) {
			fontSizeRatio = '1.4rem';
			rowHeight = 42;
		} else if (width > 991) {
			fontSizeRatio = '1.2rem';
			rowHeight = 34;
		}
		console.debug('width', width)
		console.debug('fontSizeRatio', fontSizeRatio)
		console.debug('rowHeight', rowHeight)
		return (
			// <Grid container id='trans-tran-grid'  style={{"height": "94vh" }}  >
				// <Grid item  className='col-md-6 mx-auto'>
					<div id='trans-tran-grid' className={agStyles} style={{"height": "94vh" }}>
						<AgGridReact
							autoSizeStrategy={autoSizeStrategy}
							gridOptions={{
								defaultColDef: {
									resizable: true,
									cellStyle: { 'padding-left': '2px', 'padding-right': '2px', 'font-size': fontSizeRatio },
								},
								rowHeight: rowHeight,
								getRowStyle: params => {
								  if (params.node.rowIndex % 2 === 0) {
									return { background: Constants.COLORs.BOODIDA };
								  }
								},
							}}
							onRowDragEnter={this.onRowDragEnter}
							onRowDragEnd={this.onRowDragEnd}
							onGridReady={this.onGridReady}
							onRowDragLeave={this.onRowDragLeave}
							columnDefs={this.state.tranColDef}
							rowData={this.state.termTrans}
							getRowClass={this.handleRowHighlights}
							rowSelection="multiple"
							onSelectionChanged={this.onSelectionChanged.bind(this)}
							rowDragManaged={true}
                            animateRows
                            enableCellTextSelection="true"
                            ensureDomOrder="true"
							// pagination={!this.state.gridEditMode}
							// paginationPageSize={25}
						/>
					</div>
				// </Grid>
			// </Grid>
		)
	}

	renderModalNewTran() {
        // console.log("adding selected row date to new tran dialog:" + JSON.stringify(selected));
        // if (Array.isArray(selected) && selected.length === 1 && selected[0].date) {
        //     newTran.date.value = selected[0].date.substr(0, 10);
        // } 
		return (
			<NewTran
				display={this.state.open.createModal}
				onCancel={() => {
					this.handleCloseModal();
				}} 
				onSubmit={() => {
						this.handleCloseModal();
						// this.onSubmitNewTransactionOrder();
						this.handleRefreshRequest();
						// this.handleRecalculateAccount();
				}} 
				tranTypes={this.state.tranTypesCrDr}
				account={this.state.selectedAccount}
				isCredit={this.state.open.creditModal}
				actionUpdate={false}
				transactions={[]}
			/>
		)
	}
	
	renderModalNewChitTermTran() {
        // let selected = this.gridApi.getSelectedRows();
        // let newTran = _cloneDeep(tranObject);
        // console.log("adding selected row date to new tran dialog:" + JSON.stringify(selected));
        // if (Array.isArray(selected) && selected.length === 1 && selected[0].date) {
        //     newTran.date.value = selected[0].date.substr(0, 10);
        // } 
		return (
			<NewChitTermForm
				display={this.state.enableAddChitTerm}
				onCancel={() => {
					this.setState({ enableAddChitTerm: false });
				}} 
				onSubmit={() => {
					this.setState({ enableAddChitTerm: false });
					this.handleForceReloadAccount()
				}} 
				modeUpdate={false}
				asDialog={true}
				account={this.state.selectedAccount}
			/>
		)
	}

	renderModalUpdateTran() {
		return (
			<NewTran
				display={this.state.open.updateModal}
				onCancel={() => {
					this.handleCloseModal();
				}} 
				onSubmit={() => {
						this.handleCloseModal();
						//TODO: do below update only if cr/dr is changed.
						// this.onSubmitNewTransactionOrder();
						this.handleRefreshRequest();
						// this.handleRecalculateAccount();
				}} 
				tranTypes={this.state.tranTypesCrDr}
				account={this.state.selectedAccount}
				isCredit={this.state.open.creditModal}
				actionUpdate={true}
				transactions={this.state.rowsSelected}
			/>
		)
	}
	
	renderModalBulkUpdateTran() {
		return (
			<NewTran
				display={this.state.open.bulkUpdateModal}
				onCancel={() => {
					this.handleCloseModal();
				}} 
				onSubmit={() => {
						this.handleCloseModal();
						// this.onSubmitNewTransactionOrder();
						this.handleRefreshRequest();
						// this.handleRecalculateAccount();
				}} 
				tranTypes={this.state.tranTypesCrDr}
				account={this.state.selectedAccount}
				isCredit={this.state.open.creditModal}
				actionUpdate={false}
				multiMode={true}
				transactions={this.state.enabledBulkUpdate ? this.state.rowsSelected : []}
			/>
		)
	}
	
	renderModalTranAttach() {
        let ids = this.state.rowsSelected.reduce((arr, tran)=>{
			arr.push(tran._id);
			return arr;
		},[]);
		return (
			<Dialog open={this.state.open.attachModal}
				fullWidth={true}
				maxWidth="md"
				hideBackdrop={true}
				style={{modal: { padding: 0 }}}
				onClose={(e, reason)=>{
					if (reason === "backdropClick") this.handleCloseModal()
				}}
				PaperProps={{ style: { backgroundColor: Constants.COLORs.VANKAYA_250 }}}>
				<ReceiptManager
					display={this.state.open.attachModal}
					entity={'tran'}
					entityId={ids[0]}
					selectedAccount={this.state.selectedAccount}
					roles={this.state.roles} 
					onChange={(receipts)=>{}}/>
			</Dialog>
		)
    }
    
	renderModalLinkTranMulti() {
		return (
			<LinkTran
				display={this.state.open.linkModal}
				onCancel={() => {
					this.handleCloseModal();
				}} 
				onSubmit={() => {
						this.handleCloseModal();
						//TODO: Provide this option as a setting.
						//this.handleRefreshRequest();
						this.props.enqueueSnackbar('Please refresh the account to see link (IO) status', {
							variant : 'info'
						});
                }} 
                onError={(msg)=>{
                    this.props.enqueueSnackbar(msg, { variant : 'error' });
                }}
				tranTypes={this.state.tranTypesCrDr}
				account={this.state.selectedAccount}
				isCredit={this.state.open.creditModal}
				mode={this.state.rowsSelected.length === 1 ? "single" : "multiple"}
                // accountLineUp={linkEligibleAccounts}
                accountLineUp={this.state.accountLineUp}
                // transactions={transToLink}
                transactions={this.state.rowsSelected}
			/>
		)
	}

	
	renderModalCopyTranMulti() {
		return (
			<CopyTran
				display={this.state.open.copyModal || this.state.open.moveModal}
				onCancel={() => {
					this.handleCloseModal();
				}} 
				onSubmit={() => {
						this.handleCloseModal();
						//TODO: Provide this option as a setting.
						//this.handleRefreshRequest();
						// this.props.enqueueSnackbar('Please refresh the account to see link (IO) status', {
						// 	variant : 'info'
						// });
				}} 
				tranTypes={this.state.tranTypesCrDr}
				account={this.state.selectedAccount}
				isCredit={this.state.open.creditModal}
				mode={this.state.open.copyModal ? "copy" : "move"}
				accountLineUp={this.state.accountLineUp}
				transactions={this.state.rowsSelected}
				onError={() => {
					this.handleCloseModal();
				}}
			/>
		)
	}
	
	renderWidgetYearlyTrend() {
		return (
			<Dialog open={this.state.open.widgetYearlyTrends}
				fullWidth={true}
				maxWidth="md"
				hideBackdrop={true}
				style={{modal: { padding: 0 }}}
				onClose={(e, reason)=>{
					if (reason === "backdropClick") this.handleCloseModal()
				}}
				PaperProps={{ style: { backgroundColor: Constants.COLORs.VANKAYA_250 }}}>
				<WidgetYearlyTrend 
					title={this.state.selectedAccount.name} />
			</Dialog>
		)
	}

	renderWidgetTranTypeSplits() {
		return (
			<Dialog open={this.state.open.widgetTranTypeSplits}
				fullWidth={true}
				maxWidth="lg"
				hideBackdrop={true}
				style={{modal: { padding: 0 }}}
				onClose={(e, reason)=>{
					if (reason === "backdropClick") this.handleCloseModal()
				}}
				PaperProps={{ style: { backgroundColor: Constants.COLORs.VANKAYA_250 }}}>
				<WidgetTranTypeSplits 
					title={this.state.selectedAccount.name} />
			</Dialog>
		)
	}

	renderChitPaymentDashboard() {
		return (
			// <Dialog open={this.state.open.chitPaymentDashboard}
			// 	fullWidth={true}
			// 	maxWidth="lg"
			// 	hideBackdrop={true}
			// 	style={{modal: { padding: 0 }}}
			// 	onClose={(e, reason)=>{
			// 		if (reason === "backdropClick") this.handleCloseModal()
			// 	}}
			// 	PaperProps={{ style: { backgroundColor: Constants.COLORs.SABBU }}}>
			// 	{this.state.open.chitPaymentDashboard && <ChitPayDashboard />}
			// </Dialog>
			<ChitPayDashboard 
				selectedAccount={this.state.selectedAccount}
				showDueColumn={this.state.dashboardShowDueColumn} />
		)
	}
}

Tran.propTypes = {
	classes : PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(withStyles(TranStyle)(Tran)));
